// extracted by mini-css-extract-plugin
module.exports =  {"root":"_0d624b9a27--root--G84Hq","text-content":"_0d624b9a27--text-content--R4lwr","icon":"_0d624b9a27--icon--nq3tH"};